import styled from 'styled-components'

import backgroundSVG from '../assets/card-bg.png'

interface IPhysicalCardPinPresenterStyledProps {}

export const PhysicalCardPinPresenterStyled = styled.div<IPhysicalCardPinPresenterStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  position: relative;
  overflow: hidden;

  width: ${(props) => props.theme.typography.pxToRem(320)};
  height: ${(props) => props.theme.typography.pxToRem(320 / 1.58)};
  border-radius: ${(props) => props.theme.typography.pxToRem(8)};
  padding: ${(props) => props.theme.space.medium};

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background-color: black;
  /* background-image: url(${backgroundSVG}); // Add this back in when Airwallex physical cards are printed with the Procurify logo */
  background-size: cover;

  color: ${(props) => props.theme.colors.white};

  iframe {
    max-height: ${(props) => props.theme.typography.pxToRem(92)};
  }
  .network-logo {
    min-height: ${(props) => props.theme.typography.pxToRem(30)};
    max-height: ${(props) => props.theme.typography.pxToRem(40)};
  }

  .disabled-mask {
    display: none;

    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    background-color: ${(props) => props.theme.colors.darkGrey};
    opacity: 0.7;

    pointer-events: none;

    .icon-wrapper {
      height: ${(props) => props.theme.typography.pxToRem(40)};
      width: ${(props) => props.theme.typography.pxToRem(40)};
      border-radius: 50%;

      display: flex;
      justify-content: center;
      align-items: center;

      position: absolute;
      top: calc(50% - ${(props) => props.theme.typography.pxToRem(20)});
      right: ${(props) => props.theme.space.medium};

      &-lock {
        color: ${(props) => props.theme.colors.text.inverse};
      }
      &-times {
        background-color: ${(props) => props.theme.colors.error};
      }
    }
  }
`
